export default __webpack_public_path__ + "static/media/GearTriumph.3931807f.jpg";